








import {Component, Mixins} from 'vue-property-decorator';

import LiveMeta from '@/mixins/LiveMeta';

@Component({})
export default class ErrorLayout extends Mixins(LiveMeta) {
}
